import { Field, SituationObject } from '@yes.technology/react-toolkit'
import { AllowedLocales } from 'shared/utils/date/formatDate'
import { FieldValues, GroupedFieldValues } from '../../types/fields'
import { FilteractionSelectionProps } from './FilteractionSelection'
import getQueryDataFromFilteraction from './getQueryDataFromFilteraction'

type GetOnSelectFilteractionProps = {
  sections: Field[][]
  situations: Pick<
    SituationObject,
    'code' | 'des' | 'uuid' | 'uuid_Objectclass'
  >[]
  initialFieldValues: FieldValues
  handleChange?: (value: GroupedFieldValues) => void
  handleClear?: () => void
  handleComposition: (composition: string) => void
  setGroupPosition: (position: number) => void
  setChangedKeysData?: (value: GroupedFieldValues) => void
  locale: AllowedLocales
}

const getOnSelectFilteraction =
  ({
    sections,
    situations,
    initialFieldValues,
    handleChange = () => '',
    handleClear = () => '',
    handleComposition,
    setGroupPosition,
    setChangedKeysData,
    locale
  }: GetOnSelectFilteractionProps): FilteractionSelectionProps['onSelectFilteraction'] =>
  (filteraction) => {
    handleClear()

    if (!filteraction) {
      return
    }

    const { queryData, composition, changedKeysData } =
      getQueryDataFromFilteraction({
        initialFieldValues,
        sections: sections,
        situations,
        filteraction,
        locale
      })

    handleChange(queryData)
    handleComposition(composition)
    setGroupPosition(queryData ? Object.keys(queryData).length : 1)
    setChangedKeysData?.(changedKeysData)
  }

export default getOnSelectFilteraction
